import React from 'react';

import { type BaseSvgProps, colorToHexCode } from '../../utils';

export const Download = ({
  width = 12,
  primaryColorHexCode = colorToHexCode.black,
  'data-testid': testId,
}: BaseSvgProps) => (
  <svg
    data-testid={testId}
    width={width}
    height={width}
    viewBox="0 0 13 27"
    className="shrink-0"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3755 20.3838H1.12549L1.12549 18.9341L12.3755 18.9341V20.3838Z"
      fill={primaryColorHexCode}
    />
    <path
      d="M11.3703 11.0957L12.3755 12.1008L6.75048 17.7258L1.12549 12.1008L2.13064 11.0957L5.99662 15.039V6.5H7.50435V15.039L11.3703 11.0957Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
